"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("./createIcon"));
var ArrowRight = createIcon_1.default('ArrowRight', function (_a) {
    var color = _a.color;
    return (react_1.default.createElement("path", { fill: color, d: "M6.4 6L4.3 3.9c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.8 2.8c.4.4.4 1 0 1.4L5.7 9.5c-.4.4-1 .4-1.4 0s-.4-1 0-1.4L6.4 6z" }));
}, {
    viewBox: '0 0 12 12',
    size: 12,
});
exports.default = ArrowRight;
